import { PostPlaceholderImage } from '@components/Post';
import { GuidesAndTipsDocument } from '@core/content';
import { getGuiedsAndTipsDocumentPath } from '@core/content';
import { format, parse } from 'date-fns';
import { GatsbyImage } from 'gatsby-plugin-image';
import React, { FC } from 'react';

interface Props {
  document: GuidesAndTipsDocument;
  className?: string;
}

const PostSidebarRelatedTopicCard: FC<Props> = ({ document, className }) => {
  const image = document.headerImage?.childImageSharp.thumbnail;
  const title = document.itemContent.content.headerTitle;

  return (
    <a href={getGuiedsAndTipsDocumentPath(document)} className={`hover:opacity-75 flex flex-row items-center ${className}`}>
      <div className="rounded-lg shrink-0 mr-6 bg-blue-200">
        {image ? (
          <GatsbyImage className="rounded-lg" alt={title} image={image} />
        ) : (
          <PostPlaceholderImage className="rounded-lg" alt={title} />
        )}
      </div>

      <div>
        <span className="block font-bold text-ocean-blue leading-6 mb-1">{title}</span>
        <span className="text-sm font-medium">
          {format(parse(document.fields?.createdAt || '', 'yyyy-MM-dd HH:mm:ss', new Date()), 'MMMM dd, yyyy')}
        </span>
      </div>
    </a>
  );
};

export default PostSidebarRelatedTopicCard;
